import { useLanguage } from "@/hooks/useLanguage";
import { pulseFor, type CountdownPhase } from "@/lib/countdown/worldCupCountdown";
import { useMobileMatchMode } from "@/lib/launchHardening/mobileMatchMode";

/**
 * Tiny heartbeat pill — visual only. Respects mobile match-mode glow scale.
 */
export function CountdownPulse({ phase }: { phase: CountdownPhase }) {
  const { t } = useLanguage();
  const mmm = useMobileMatchMode();
  const p = pulseFor(phase);
  if (p.phase === "idle") return null;

  const glow = (4 + p.intensity * 18) * mmm.glowScale;
  const beat = `${Math.round(p.beatMs * (mmm.profile === "low" ? 1.4 : 1))}ms`;

  return (
    <div
      role="status"
      aria-label={t(p.label)}
      className="inline-flex items-center gap-2 rounded-full border border-border/60 bg-background/80 px-3 py-1 backdrop-blur"
      style={{ boxShadow: `0 0 ${glow}px oklch(0.7 0.22 22 / ${0.3 + p.intensity * 0.5})` }}
    >
      <span
        aria-hidden
        className="inline-block h-2 w-2 rounded-full bg-rose-500"
        style={{ animation: `pulse ${beat} cubic-bezier(0.4,0,0.6,1) infinite` }}
      />
      <span className="text-[10px] font-bold uppercase tracking-wider">
        {t(p.label)}
      </span>
    </div>
  );
}
